import {pendoService} from '@/modules/common/services'
import ThryvTealiumScript from "@/modules/common/utils/thryvTealiumScript";
const userActivityPackage = 'https://d1e7vhqfrchhaw.cloudfront.net/pov/vendor-js/user_activity_package.js';

// build scripts only once
let firstRun = true

const set = (account, conditions = {}, data = {}) => {
  const isTealiumEnabled = conditions.hasFeature('thryv_tealium_script')
  let pendoEnabled = account.external_integrations.pendo.enabled && !isTealiumEnabled;
  if (firstRun) {
    if (pendoEnabled) {
      let pendoAPIkey = (conditions?.isMobile || conditions?.isMobileApp)  ? account.external_integrations.pendo.mobile : account.external_integrations.pendo.desktop
      pendoService.buildPendo(pendoAPIkey)
    }
    if (isTealiumEnabled) {
      runTealium(account, data.numOfStaff);
    }
    if (account.business.has_logrocket_script) runLogrocketScript(account)
  }

  // sending data that depends on the user activities - so we call the function more than once
  if (pendoEnabled) pendoService.initPendo(account, conditions?.isStar, conditions?.isMobile, data?.matterTerm, data?.numOfStaff)
  if (conditions.hasFeature('session_timeout')) {
    addUrlScriptToWindow(userActivityPackage)
  }

  firstRun = false
}

function runLogrocketScript(account){
  let logrocket_event_method = account.brand.logrocket_script[0]
  let logrocket_src_script = account.brand.logrocket_script[1]
  let logrocket_script =  account.brand.logrocket_script[2]
  let data = {
    "%THRYV_ID%": account.business.uid,
    "%NAME%": account.staff.full_name.replace(/[^a-zA-Z0-9 ]/g, ""),
    "%STAFF_ID%": account.staff.uid,
    "%LOGIN_EMAIL%": account.staff.email
  }
  for (const property in data) {
    logrocket_script = logrocket_script.replace(property, data[property])
  }
  let method_element = document.createRange().createContextualFragment(logrocket_event_method)
  document.head.appendChild(method_element)
  let src_element = document.createRange().createContextualFragment(logrocket_src_script)
  document.head.appendChild(src_element)
  let element = document.createRange().createContextualFragment(logrocket_script)
  document.head.appendChild(element)
}

function runTealium(account, numberOfStaff){
  if(!!window.thryv_tealium){
    return
  }
  const tealiumScript = ThryvTealiumScript.getScriptAsString({
    businessData: account.business,
    staffData: account.staff,
    settingsData: account.settings,
    profileData: account,
    numberOfStaffs: numberOfStaff,
  })
  addScriptToWindow('thryv_tealium',tealiumScript)
}

export default {
  set,
  addUrlScriptToWindow,
};

function addScriptToWindow(id, script){
  let element = document.createElement('script')
  element.innerHTML = script
  element.setAttribute('id',id)
  document.getElementsByTagName('head')[0].appendChild(element)
}

function addUrlScriptToWindow(url){
  let element = document.createElement('script')
  element.setAttribute('src', url)
  document.getElementsByTagName('head')[0].appendChild(element)
  return element
}
